import React, { useState } from 'react'
import DefaultSwitch from '@mui/material/Switch'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'
import { useTranslation } from 'react-i18next'

interface SwitchProps {
  defaultChecked: boolean,
  handleSwitch: () => void,
  name: string,
}

export default ({ defaultChecked, handleSwitch, name }: SwitchProps) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(defaultChecked)
  const styles = StyleSheet.create({
    root: {
      width: '72px',
      height: '28px',
      padding: 0,
    },
    switchBase: {
      padding: 1,
    },
    thumb: {
      color: constants.colors.white,
      width: 24,
      height: 24,
      margin: 1,
    },
    track: {
      border: '1px solid white',
      borderRadius: 32,
      backgroundColor: checked ? constants.colors.green : constants.colors.background,
      opacity: 1,
      ':after': {
        color: constants.colors.white,
        fontSize: 14,
        position: 'absolute',
        content: checked && `"${t('yes').toUpperCase()}"`,
        top: 4,
        left: 8,
      },
      ':before': {
        color: constants.colors.white,
        fontSize: 14,
        position: 'absolute',
        content: !checked && `"${t('no').toUpperCase()}"`,
        top: 4,
        right: 7,
      },
    },
    checked: {
      transform: 'translateX(44px)',
    },
  })

  const handleChange = (event) => {
    setChecked(event.target.checked)
    handleSwitch()
  }

  return (
    <div>
      <DefaultSwitch
        classes={{
          root: css(styles.root),
          switchBase: css(styles.switchBase),
          thumb: css(styles.thumb),
          track: css(styles.track),
          checked: css(styles.checked),
        }}
        name={name}
        onChange={handleChange}
        checked={checked}
      />
    </div>
  )
}
